import { FunctionComponent, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { MarkdownEditor } from 'src/shared/MarkdownEditor';
import { PlanTitle, PlanContainer, PlanExpandToggle } from './styled';

const PREVIEW_CHAR_LIMIT = 600;

interface Props {
    plan: string;
    title?: string;
}

const ExpandablePlan: FunctionComponent<Props> = ({ plan, title = 'Plan' }) => {
    const [expanded, setExpanded] = useState(false);
    const isLongPlan = plan.length > PREVIEW_CHAR_LIMIT;

    return (
        <>
            <PlanTitle>{title}</PlanTitle>
            <PlanContainer
                data-color-mode="dark"
                collapsed={isLongPlan && !expanded}
            >
                <MarkdownEditor value={plan} readOnly />
            </PlanContainer>
            {isLongPlan && (
                <PlanExpandToggle onClick={() => setExpanded((p) => !p)}>
                    {expanded ? (
                        <>
                            Collapse <ExpandLessIcon fontSize="small" />
                        </>
                    ) : (
                        <>
                            Expand <ExpandMoreIcon fontSize="small" />
                        </>
                    )}
                </PlanExpandToggle>
            )}
        </>
    );
};

export default ExpandablePlan;
